// Generated by Claude Code
import { WorkOrdersPage } from '#components/domain/operations/work-orders/work-orders-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/work-orders/')({
  component: RouteComponent,
  staticData: {
    title: 'Work Orders',
  },
  // Other params (the `slice` an Analysis link adds) pass through untouched; `useListSlice` reads them.
  validateSearch: (search: Record<string, unknown>): { workOrderStepTemplateId?: string } & Record<string, unknown> => ({
    ...search,
    workOrderStepTemplateId: (search.workOrderStepTemplateId as string) ?? undefined,
  }),
})

function RouteComponent() {
  // Limited readers (any READ_LIMITED slot) may enter; the backend + limited-
  // access whitelists decide which properties they actually see.
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.WORK_ORDERS)} redirectOnNotAuthorized>
      <WorkOrdersPage />
    </PermissionGuard>
  )
}
